const zh = {
    music: '网易云音乐',
    findMusic: '发现音乐',
    myMusic: '我的音乐',
    friend: '朋友',
    musician: '音乐人',
    download: '下载',
    autoGenerate: '自动生成',
    date: '日期',
    lang: '语言',
    text: '文本',
    theme: '主题',
    chooseDate: '请选择日期',
    headerNewWindow: '新窗口',
    baseRole: '普通角色',
    functionalHR: '职能HR',
    systemName: '绩效管理系统',
    userManage: '用户管理',
    roleType: '角色类型',
    roleOrder: '角色排序',
    roleManage: '角色管理',
    roleCode: '角色编码',
    roleDetail: '角色详情',
    userName: '用户名称',
    roleName: '角色名称',
    search: '查询',
    reset: '重置',
    placeholder: '请选择',
    placeholderSelect: '请选择',
    userId: '用户ID',
    employeeNumber: '员工编号',
    chineseName: '中文名',
    AuthorizedRole: '已授权角色',
    operation: '操作',
    roleAuthorization: '角色授权',
    permAuthorization: '数据授权',
    permissionCode: '许可编码',
    permissionName: '许可名称',
    permissionDetail: '许可详情',
    permissionID: '许可ID',
    cancel: '取消',
    confirm: '确定',
    add: '新增',
    edit: '编辑',
    del: '删除',
    exit: '退出',
    exit2: '退出',
    save: '保存',
    submit: '提交',
    explain: '说明',
    authorizedMenu: '授权菜单',
    description: '描述',
    authorization: '授权',
    dataAuthorization: '数据授权',
    input: '请输入',
    select: '请选择',
    resourceManage: '资源管理',
    resourceName: '资源名称',
    resourceCode: '资源编码',
    resourceOrder: '资源排序号',
    resourcePath: '资源请求路径',
    parentID: '父资源ID',
    resourceType: '资源类型',
    createDate: '创建时间',
    updateDate: '更新时间',
    successMsg: '操作成功',
    failMsg: '操作失败',
    addMsg: '新增成功',
    editMsg: '编辑成功',
    delMsg: '删除成功',
    addFailMsg: '新增失败',
    editFailMsg: '编辑保存失败',
    delFailMsg: '删除失败',
    delConfirmMsg: '是否删除此项目',
    delConfirmTips: '是否删除此人员？',
    delConfirmTips2: '确定删除吗？',
    index: '序号',
    typeId: '类别ID',
    code: '编码',
    content: '内容',
    appliablePerson: '考核大类',
    personType: '人员类型',
    KPIfrequency: '默认KPI考核频率',
    status: '状态',
    state: '状态',
    indexModel: '指标模型',
    indexConfig: '指标模型',
    on: '启用',
    off: '停用',
    frequency: '频率',
    personTypeConfig: '考核类别设置',
    modelStandard: '模型配置',
    indicatorlibrary: '指标库',
    compositeIndicator: '组合指标',
    compositeIndex: '组合指标',
    viewDetail: '查看详情',
    modelName: '模型名称',
    value: '值',
    targetValue: '目标值',
    evaluationObjectives: '评估目标',
    clone: '复制',
    year: '年度',
    modelConfig: '模型设置',
    type: '类型',
    import: '导入',
    downloadTemp: '下载模板',
    export: '导出',
    maintainTemp: '维护模板',
    importTemp: '导入模板',
    annual: '年度',
    number: '工号',
    name: '姓名',
    department: '部门',
    position: '职位',
    level: '员工级别',
    staffLevel: '员工级别',
    templateType: '模板类型',
    templateName: '模板名称',
    templateDescription: '模板描述',
    yearBonusTemp: '年终奖模板',
    businessUnits: '业务单位',
    onthespot: '签约地',
    oper: '操作',
    simplifyDescription: '简体中文描述',
    traditionalDescription: '繁体中文描述',
    englishDescription: '中文描述',
    targetName: '指标名称',
    kpiOrNodeWorkObjective: 'KPI或节点工作目标',
    departmentKPI: '部门KPI',
    businessOrWorkPlan: '业务/工作计划（项目）',
    targetYear: '目标年度',
    historyYear: '复制年度',
    CopyYear: '复制年度',
    unit: '单位',
    challenge: '挑战',
    budget: '预算',
    lowThanBudget: '低于预算',
    minLimit: '下限',
    indicatorTypes: '指标类型',
    indicatorClassification: '指标分类',
    indexClassification: '指标分类',
    indicatorDescrtion: '指标说明',
    indicatorCode: '指标编码',
    indexCode: '指标编码',
    functionalPersonelSubclass: '职能人员子类',
    dataResource: '数据来源',
    dataResource2: '数据来源',
    calculationMethod: '计算方法',
    calculationRule: '计算规则',
    whetherApplyTheDefaultModel: '是否适用指标模型',
    effectDate: '生效时间',
    chooseIndexModel: '选择指标模型',
    executiveIndicatorModel: '高管指标模型',
    executiveModelName: '高管模型名称',
    baseIndicator: '基础指标',
    composeIndicator: '组合指标名称',
    time: '时间',
    close: '停用',
    returnInfo: '3秒后返回',
    SaleAssessment: '销售/市场类（考核）',
    SaleComplaint: '销售/市场类（申诉处理）',
    ExecutiveAssessment: "高管类（考核）",
    assessType: 'KPI/STI',
    assessMethod: '考核方式',
    funcType: '职务类别',
    period: '周期',
    period2: '周期',
    assessmentFrequency: '考核频率',
    indicatorAttachmentDescr: '指标附件说明',
    attachment: '附件',
    saleRevenuePersonnel: '销售收入-个人',
    personnelProfit: '利润-个人',
    tenThousand: '万元',
    personnelChanges: '异动待处理名单',
    query: '查询',
    maintain: '维护',
    assessYear: '考核年度',
    assessStartDate: '考核周期开始时间',
    assessEndDate: '考核周期结束时间',
    departmentNumber: '部门编号',
    mainOrPartTime: '主/副岗',
    businessAssessPersonId: '业务线考核人ID',
    businessAssessPersonName: '业务线考核人',
    partTimeAssessIndDesc: '副岗考核',
    weight: '权重',
    weighting: '权重',
    entryDate: '入职日期',
    leaveDate: '离职日期',
    transferDate: '转岗日期',
    maintenanceRecords: '维护记录',
    administrativeLine: '行政线',
    businessLine: '业务线',
    haveBusiness: '双线考核',
    mainAndPostWeight: '主副岗权重',
    subclass: '子类',
    firstAssessor: '一级考核人',
    assessorType: '被考核人类型',
    dottedLineReporterOfAppraisee: '被考核人的虚线汇报人',
    supervisorLineOfDdottedLineReporter: '虚线汇报人的直线上级',
    record: '记录',
    modifyPerson: '修改人',
    modifyTime: '修改时间',
    queryFailed: '查询失败',
    submittedSuccess: '提交成功',
    submittedFail: '提交失败',
    savedSuccess: '保存成功',
    editSuccess: '编辑成功',
    savedFail: '保存失败',
    newProcess: '新进处理',
    noNeedProcess: '无需处理',
    salaryType: '薪资类别',
    salaryTypeChangeDate: '薪资类别变化日期',
    sourceDeptName: '原部门',
    sourcePosttionName: '原职位',
    sourceLevel: '原职级',
    targetNameNew: '目标名称',
    applicableCompany: '适用公司',
    noData: '暂无数据',
    assessmentCategory: '考核类别',
    appraiseCategory: '考核类别',
    fillInActualValue: '填写实际值',
    actualValueOfSpecialPersonnel: '特殊人员实际值',
    targetManagement: '目标管理',
    compTargetManagement: '公司目标管理',
    scoringManagement: '评估管理',
    setSpecialGoals: '设置特殊目标',
    detail: '详情',
    copyCategory: '复制类别',
    copyEnterpriseObjectives: '复制企业目标',
    dataPermission: '数据许可',
    targetDescription: '目标描述',
    specialPersonnelObjectives: '特殊审批人目标',
    enterpriseObjectives: '企业目标',
    targetSetting: '目标设置',
    addIndicator: '添加指标',
    selectIndicators: '选择指标',
    copySelfScheme: '复制本人方案',
    copyOthersScheme: '复制他人方案',
    schemesProportion: '方案占比',
    startDate: '开始日期',
    endDate: '结束日期',
    target: '目标',
    remark: '备注',
    remarks: '备注',
    copyAppraisalScheme: '复制考核方案',
    currentYear: '当前年度',
    copyYear: '复制年度',
    assessmentList: '考核列表',
    setTarget: '设定',
    targetSetting2: '设定',
    targetConfirm: '确认',
    originalAssessmentScheme: '原考核方案',
    proportion: '占比',
    targetModificationDescription: '目标修改说明',
    schemeModificationType: '方案修改类型',
    addScheme: '添加方案',
    targetModification: '目标修改',
    schemes: '方案',
    assessmentCycle: '考核周期',
    indicatorModificationType: '指标修改类型',
    applicationScope: '适用范围',
    saleAndMarketTargetSetting: '销售/市场类（目标设置）',
    saleAndMarketTargetModify: '销售/市场类（目标修改）',
    seniorManagementTarget: '高管类（目标）',
    yes: '是',
    no: '否',
    maintainTarget: '维护目标',
    modifyTarget: '修改目标',
    appraisalQuery: '考核过程&结果',
    resultQuery: '年度综合结果',
    see: '查看',
    baseInfo: '基础信息',
    targetProportion: '目标占比',
    enterValue: '请输入数值',
    selectCombinationIndicator: '选择组合指标',
    indicatrix: '指标',
    printPreview: '打印预览',
    assessmentProcess: '考核流程',
    operator: '操作人',
    operationTime: '操作时间',
    historicalDocuments: '历史单据',
    treatment: '处理情况',
    handler: '处理人',
    partTimeEndDate: '副岗失效日期',
    weightDistribution: '权重分配',
    weightDistributionConfig: '类型设置',
    notKpiWeight: '非年度KPI权重',
    kpiWeight: '年度KPI权重',
    STIWeight: 'STI权重',
    weightProportion: '权重占比',
    adjustmentRemarks: '调整备注',
    proportionSchemes: '方案占比',
    stiAchievementRate: 'STI达成率',
    kpiAchievementRate: 'KPI达成率',
    stiAchievementRateOfCompany: 'STI达成率-公司',
    stiAchievementRateOfPerson: 'STI达成率-个人',
    adjustment: '调整',
    targetDetails: '目标详情',
    calculatedAccordingToActualSales: '按照实际销售计算',
    processPreview: '流程预览',
    newEmployeesIDP: '新增员工IDP',
    staff: '员工',
    copyInterviewRecords: '复制面谈记录',
    addInterviewRecords: '新增面谈记录',
    copyFromTMC: '从TMC复制',
    affirm: '确认',
    historicalObjectives: '历史目标',
    actual: '实际',
    achievementRate: '达成率',
    comprehensiveAchievementRate: '综合达成率',
    unlock: '解锁',
    applicableDepartment: '适用部门',
    targetType: '目标类型',
    challengeGoal: '挑战目标',
    basicRequirements: '基本要求',
    addTarget: '添加目标',
    addTo: '添加',
    appraisalCycleSetting: '周期/目标制定人设置',
    isDefaultKPIFrequency: '默认考核周期',
    periodYear: '年',
    newAppraisalCycle: '新增考核周期',
    KPIAssessmentFrequency: 'KPI考核周期',
    STIAssessmentFrequency: 'STI考核周期',
    isSetGoalsForEmployees: '员工制定目标',
    directReports: '直接下属',
    KPIAnnualScore: 'KPI年度得分',
    abilityScore: '能力得分',
    comprehensiveScore: '综合得分',
    annualComprehensiveEvaluation: '年度综合考评',
    confirmResult: '确认结果',
    firstAssessmentLaborNo: '第一考核人工号',
    firstAssessorSpecialist: '第一考核人专员',
    secondAssessmentLaborNo: '第二考核人工号',
    secondAppraiser: '二级考核人',
    HRJobNumber: 'HR工号',
    PersonNumberInChargeOfTheCompany: '公司负责人工号',
    PersonInChargeOfTheCompany: '公司负责人',
    originalPersonnelType: '原人员类型',
    newPersonnelType: '新人员类型',
    reserveBusinessLine: '是否保留解锁前的业务线',
    reserveConcurrentPost: '是否保留解锁前的兼岗',
    setGoals: '确定目标',
    departmentalObjectives: '部门目标',
    copyMyTarget: '复制本人目标',
    copyOtherPeopleGoals: '复制他人目标',
    additionalInstructions: '附加说明',
    additionalNotes: '附加说明',
    cycleSetting: '周期设置',
    goalSetting: '目标设定',
    modify: '修正',
    retargeting: '重设',
    completionStatus: '输入',
    determineResult: '确定结果',
    resultConfirmation: '年度结果确认',
    IDPCreation: 'IDP创建',
    modificationType: '修改类型',
    modificationReason: '修改原因',
    role: '角色',
    personnel: '人员',
    approvalOpinions: '审批意见',
    viewApprovalComments: '查看审批意见',
    start: '开始',
    complete: '完成',
    executiveType: '高管类型',
    scoreRules: '计分规则',
    modelTargetValue: '销售STI目标',
    organization: '组织',
    defaultKPIPeriod: '默认周期设置',
    KPIPeriodChangeNode: '您正在修改父级设置，修改父级设置会覆盖子级的设置，是否继续',
    unannualKPIWeight: '非年度KPI权重',
    annualKPIWeight: '年度KPI权重',
    weightConfig: '权重设置',
    deleteTips: '至少保留一项数据',
    chooseTips: '至少选择一项数据',
    chooseOneTips: '只能选择一项数据',
    alreadyExit: '当前数据已存在',
    dbLineAssConfig: '权重设置',
    // dbLineAssConfig: '双线考核权重维护',
    time: '时间',
    importFail: '导入失败',
    importSuccess: '导入成功',
    importExcelTips: '请上传正确的excel模板',
    autoFillTips: '无需填写，自动生成',
    executive: '高管',
    weightDistributionCheckTips: "不能为空且不超过100字",
    WeightSetting: "权重设置",
    AssessmentWeight: "考核权重",
    required: "不能为空",
    notMeetRequirements: "要求[0-100]的数",
    CurrentYearDataAlreadyExists: "当前年度数据已存在",// Current year data already exists
    keepAtLeastOne: '至少保留一条',
    administrative_and_business_required_100: '行政线和业务线之和要求为100',
    not_maintained: "未维护",
    draft: "草稿",
    imported: "已导入",
    submitted: "已提交",
    Modification_to_be_submitted: "修改待提交",
    target_confirmed: "目标已确认",
    maintained: "已维护",
    unlocked: "已解锁",
    aborted: "已中止",
    expired: "已失效",
    instruction_template: "说明模板",
    January: "1月",
    February: "2月",
    March: "3月",
    April: "4月",
    May: "5月",
    June: "6月",
    July: "7月",
    August: "8月",
    September: "9月",
    October: "10月",
    November: "11月",
    December: "12月",
    applicable_personnel: "适用人员",
    manual_calculation: "手工计算",
    newExecutives: '新增高管',
    seniorExecutive: '高管',
    english: '英文',
    chineseAndEnglish: '中英文',
    combinedWeight: '权重合计',
    compositeAchievementRate: '综合达成率',
    targetNameCheckTips: '请输入目标名称',
    targetProportionCheckTips: '请输入目标占比',
    startDateCheckTips: '请选择开始日期',
    endDateCheckTips: '请选择结束日期',
    targetIdCheckTips: '请选择说明模板',
    appealDetails: '申诉情况',
    appealExplain: '申诉说明',
    additionalPoints: '附加分',
    additionalPointsInstructions: '附加分说明',
    additionalInstructions: '附加说明',
    gradingRule: '评分规则',
    score: '评分',
    completeStatus: '完成情况',
    achievementRateAdditionalPoints: '达成率附加分',
    achievementRateAdditionalNotes: '达成率附加分说明',
    indexAttachmentUpload: '指标附件上传',
    set: '设置',
    appeal: '申诉',
    upload: '上传',
    appealTips: '请在三个工作日内确认，逾期未确认，视同确认。如有异议请在确认后提交修正申请。',
    appealTips2: '请您确认您的考核目标，如有异议需在10个工作日内提出修正，逾期未提出，视同确认。',
    appealTips3: '请您确认您的考核结果，超出三个工作日视同确认。',
    appealTips4: '请您确认您的考核结果，如有异议需在10个工作日内提出申诉，逾期未提出，视同确认。',
    appealTips5: '请确认您的考核结果，三个工作日内未确认，系统将自动确认。',
    dbAppeal: '二次申诉',
    actualCompleteRate: '实际完成率',
    firstAppealScore: '一次申诉评分',
    secondAppealScore: '二次申诉评分',
    theOriginalKPIScore: '原KPI评分',
    origin: '原',
    end: '结束',
    appealAttachment: '申诉附件',
    investigate: '调查情况',
    suggestedSolutions: '建议解决方案',
    appealType: '申诉处理',
    maintainOriginalState: '维持原结果',
    modifyTheResults: '修改结果',
    dateTips1: '开始日期不能大于结束日期',
    dateTips2: '结束日期不能小于开始日期',
    indexWeight: '指标权重',
    targetCannotBeEmpty: '目标不能为空',
    originalTarget: '原目标',
    newTarget: '新目标',
    logout: '退出登录',
    downloadSuccessful: '下载成功',
    downloadFailed: '下载失败',
    selectAtLeastOnePiece: '至少选择一条数据',
    stiDesc: '按公司实际销售计算',
    indexUnit: '指标单位',
    tipDesc100: '每个方案中的指标权重之和要等于100',
    copySuccessful: '复制成功',
    copyFail: '复制失败',
    selectAData: '请选择一条数据',
    printPreviewFailed: '打印预览失败',
    KPIAssessmentFrequencyCheckTips: '请输入KPI考核频率',
    setByEmployeeCheckTips: '请选择是否是员工本人设置目标',
    appraisalCyclePersonCheckTips: '请先选择考核周期设置人员',
    appraisalFrequencySetCheckTips: '默认考核频率已设置和未设置的不能进行批量操作',
    setSeparatelyCheckTips: '是10月份后转岗人员，需要单独设置',
    yearCheckTips: '年度不能为空',
    departmentCheckTips: '部门不能为空',
    targetNameValueCheckTips: '目标名称不能为空',
    departmentTargetEmptyTips: '暂未设置部门目标',
    copyYearCheckTips: '请选择复制年度',
    copyTargetCheckTips: '请选择复制目标',
    appraisalTargetCheckTips: '请选择考核目标',
    modelCheckTips: '模型不一致，无法复制',
    copyTargetEmptyTips: '复制的目标指标为空，无法复制',
    result: '结果',
    startTime: '开始时间',
    endTime: '结束时间',
    employeeID: '员工ID',
    departmentID: '部门ID',
    employeeRecords: '员工记录',
    jobClassification: '职务分类',
    weightOfMainAndAuxiliaryPosts: '主副岗权重',
    transactionDate: '异动日期',
    assessId: '考核ID',
    operationReason: '操作原因',
    salaryTypeChange: '薪资类别变化',
    salaryChangeDate: '薪资异动日期',
    originalEmployeeLevel: '原员工级别',
    originalSalaryCategory: '原薪资类别',
    MainOrAuxiliaryPost: '主/副岗',
    treatmentRecord: '处理记录',
    approverType: '审批人类型',
    addIndicatorGroup: '添加指标组',
    indicatorGroup: '指标组',
    notFilledIn: '未填写',
    secondaryConfirm: '确定提交吗？',
    approveTime: '审批日期',
    secondaryConfirmDelete: '确认删除吗？',
    selectedPerson: '已选中人员',
    selectPerson: '选择人员',
    pleaseComplete: '请填写完整',
    weightLessThan100: '权重之和要小于100',
    preview: '预览',
    objectDescOrActionPlan: '目标说明/行动计划',
    approvalNode: '审批节点',
    approver: '审批人',
    approvalDate: '审批日期',
    oaProcessNo: 'OA流程单号',
    QuickEntry: '快捷入口',
    more: '更多',
    todo: '我的待办',
    done: '我的已办',
    personinfo: '个人信息',
    lv: '级别',
    commonLinks: '常用链接',
    myAppraise: '我的绩效',
    teamAppraise: '团队绩效',
    return: '返回',
    model: '模型',
    zh: '简体描述',
    czh: '繁体描述',
    en: '英文描述',
    setSalesSTITarget: '设置销售STI目标',
    detailed: '明细',
    new: '新增',
    requiredItemsCheckTips: '必填项不能为空（标红输入框）',
    linkAddress: '链接地址',
    oaApprovalNo: 'OA审批单号',
    scoreManagement: '评分管理',
    AppraisalQuery: '考核查询',
    AppraisalQuery1: '考核查询-职能',
    AppraisalQuery2: '考核查询-销售/市场',
    AppraisalQuery3: '考核查询-高管',
    notEqual100: '权重之和不为100',
    empScoreConfirmTips: '请您确认您的考核结果，如有异议需在10个工作日内提出修正，逾期未提出，视同确认。',
    secondAppraiserOnlyOne: '二级考核人只能选一个',
    setValueError: '请设置指标模型',
    errFileType: '文件类型不正确',
    maxFileSizeError: '上传文件不能大于',
    sameFileError: '不能上传重名文件！',
    maxFileNameError: '文件长度不能超过80个字符',
    errFileSapce: '文件名开头或结尾包含非法字符',
    selectDialog: '选择',
    weightOfAbilityAssment: '能力考核权重',
    noPermission: '暂无权限',
    modelSortCheckTips: '指标模型值应为升降序（计算方法为按区间时）',
    modelSortCheckTips2: '的指标模型值应为升序或降序（计算方法为 "按区间折算" 或 "按区间一一对应" 时）',
    weightCheckTips: '权重不能为空',
    indexNameCheckTips: '指标名称不能为空',
    indexDescCheckTips: '指标说明不能为空',
    objectDescOrActionPlanTips: '目标说明/行动计划不能为空',
    dataSourceCheckTips: '数据来源不能为空',
    indicatorModelCheckTips: '指标模型不能为空',
    unitCheckTips: '单位不能为空',
    computeMethodCheckTips: '计算方法不能为空',
    totalWeightCheckTips: '权重总和不为百分之百',
    kpiTotalWeightCheckTips: 'KPI权重总和不为百分之百',
    stiTotalWeightCheckTips: 'STI权重总和不为百分之百',
    rolePermPath: '数据许可访问路径',
    putAway: '收起',
    open: '展开',
    richEditorPlaceHolder: '请输入正文',
    uploadFile: '上传文件',
    AppraisalYear: '考核年度',
    AppraisalType: '考核类型',
    goalSetter: '目标制定人',
    companyError: '未获取到该年度的企业指标标准模型,请去配置企业指标标准模型',
    allOption: '请选择',
    ScoringCriteria: '评分标准',
    level5: '杰出 ——完成挑战目标',
    level4: '超出预期——虽未能达到挑战目标，但能超越基本目标要求',
    level3: '合格 ——达到基本目标要求',
    level2: '部分合格 ——结果介于基本要求及下限目标之间，仍需改善',
    level1: '不合格 ——结果低于目标下限',
    levelRemark: '备注：评分可保留小数点之后一位，如3.5，4.1；得分则以四舍五入法保留小数点后两位',
    objective: '目标',
    percentageOfTarget: '目标占比',
    selectIndicator: '选择指标',
    selectPortfolioIndicator: '选择组合指标',
    indicator: '指标',
    description2: '说明',
    pleaseEnter: '请输入',
    indicatorName: '指标名称',
    portfolioIndicatorName: '组合指标名称',
    confirmOk: '确定',
    timeoutErr: '请求无响应或请求超时，请稍后重试',
    permissionErr: '您暂无此功能权限,部分数据获取失败',
    logErr: '您的登陆凭证已经过期，即将重新登陆',
    versionErr: '版本更新中，请稍等',
    annualGroup: '年度组织',
    createUser: '创建人',
    distributionManage: '强制分布管理',
    approverConfig: '审批人设置',
    DepartHeadSetting: '部门负责人设置',
    duration: '期间',
    primaryArchitecture: '一级架构',
    secondaryArchitecture: '二级架构',
    tertiaryArchitecture: '三级架构',
    quaternaryArchitecture: '四级架构',
    fifthArchitecture: '五级架构',
    sixthArchitecture: '六级架构',
    seventhArchitecture: '七级架构',
    indexNumber: '指标编号',
    completionRate: '完成率',
    isAnnualIndicator: '是否年度指标',
    salesRevenueCompany: '销售收入-公司',
    profitCompany: '利润-公司',
    salesRevenueIndividual: '销售收入-个人',
    profitIndividual: '利润-个人',
    indicatorSetting: '指标设置',
    executiveList: '高管名单维护',
    executiveTarget: '高管目标说明配置',
    assessmentInformationMaintenance: '员工信息维护',
    assessmentInformationInquiry: '员工考核查询',
    salesTargetConfirmation: '销售目标确认',
    functionalProcess: '职能评分',
    functionalAppeal: '职能申诉',
    functionAddition: '职能附加分',
    functionalTarget: '职能目标',
    saleTargetReport: '销售市场KPI/STI目标',
    salesKPIScoreReport: '销售市场KPI评分',
    salesSTIReport: '销售市场STI汇总表',
    functionalAssessmentReport: '职能绩效考核明细表',
    employeeStatus: '员工状态',
    includedInSTI: '列入STI',
    KPIScore: 'KPI评分',
    colNotFilled: '模型值至少填写一个',
    functionPermissionCheckTips: '暂无权限使用该功能',
    currentApprover: '当前审批人',
    setBonusCap: '设置人员奖金上限',
    compEval: '综合考核设置',
    rankingSettings: '排名设置',
    summaryAssessmentReport: '考核结果汇总',
    deptLevel: '层级',
    unlockDate: '解锁时间',
    operatingUser: '操作用户',
    history: '历史记录',
    appraisalResultTemplate: '考核结果模板',
    bonusCap: '奖金上限',
    automaticallyBroughtOutAndModifiable: '自动带出可修改',
    LevelID: '等级ID',
    proportion2: '比例',
    sortNumber: '排序号',
    collectionLevel: '归集等级',
    roundingRule: '取整规则',
    excellent: '优',
    excellentAndGood: '优+良',
    partiallyQualified: '部分合格',
    yearCheckTips2: '请选择年度',
    deptCheckTips: '请选择部门',
    annualGroupCheckTips: '请输入年度组织',
    PersonInChargeOfTheCompanyCheckTips: '请选择公司负责人',
    addAnnualOrganization: '新增年度组织',
    editAnnualOrganization: '编辑年度组织',
    ruleDescription: '规则描述',
    forcedDistributionRule: '强制分布规则',
    rankingModel: '排名模型',
    ruleDescriptionCheckTips: '请输入规则描述',
    addForcedDistributionRule: '新增强制分布规则',
    editForcedDistributionRule: '编辑强制分布规则',
    forcedDistributionRuleDetail: '强制分布规则详情',
    requiredCannotBeBlank: '必填项（*）不能为空',
    rankingModelSortCheckTips: '排名模型排序号不能重复',
    rankingModelProportionCheckTips: '排名模型比例和不为百分之百',
    appraisalOrganization: '考核组织',
    participationInForcedDistribution: '参与强制分布',
    departmentHead: '部门负责人',
    annualOrganizationSettings: '年度组织设置',
    appraiseeSettings: '被考核人员设置',
    psBonusCap: 'PS奖金上限',
    performanceBonusCap: '绩效奖金上限',
    performanceBonusCapEdit: '绩效奖金上限编辑',
    bonusLimitCheckTips: '请输入奖金上限',
    automaticCalculation: '自动计算',
    calculationFailed: '计算失败',
    maintenanceResults: '维护结果',
    reach: '达成',
    total: '合计',
    finalAchievementRate: '最终达成率',
    adjustmentRemarksCheckTips: '请输入调整备注',
    developmentPlanReport: '个人发展计划明细表',
    employmentType: '用工类型',
    salesUnlock: '销售解锁',
    targetUnlock: '目标解锁',
    evaluationUnlock: '评估解锁',
    gradeSimplified: '等级（简）',
    gradeTraditional: '等级（繁）',
    gradeEnglish: '等级（英）',
    fiveLevelDept: "五级部门",
    deptlead: "是否包含部门负责人",
    category1: "类别",
    staffID: "员工ID",
    computePerson: "计算人",
    computeTime: "计算时间",
    compute: "计算",
    individualSTIAchievementRate: "个人STI达成率",
    companySTIAchievementRate: "公司STI达成率",
    totalSTIAchievementRate: "STI达成率合计",
    salesSTIScoreReport: "销售市场STI评分",
    firstHalfYear: "上半年度",
    secondHalfYear: "下半年度",
    weightAchievementRate: "权重达成率",
    totalWeightCompany: "权重合计-公司",
    totalWeightIndividual: "权重合计-个人",
    salesResultsSummaryReport: "销售市场KPI/STI结果汇总表",
    performanceInterview: "绩效面谈",
    itemsToBeDeveloped: "待发展项",
    interviewRecord: "面谈记录",
    helper: "协助人",
    speedOfProgress: "进度",
    actualCompletionTime: "实际完成时间",
    progressComments: "进度评语",
    cancellationReason: "取消原因",
    actionPlan: "行动计划",
    plannedCompletionTime: "计划完成时间",
    actionDescription: "行动描述",
    outputResults: "输出结果",
    interviewTime: "面谈时间",
    functionSalesSTISummaryReport: "职能/销售市场STI汇总表",
    //汇总得分
    aggregateCalculation: "汇总计算",
    year1: "年度",
    yearOrganization: "年度组织",
    fiveDept: "五级部门",
    deptHeads: "是否包含部门负责人",
    employeeID1: "员工ID",
    compute1: "计算",
    //kpi汇总确认
    specialData: "特殊考核（双线、主副岗、异动）",
    search1: "查询",
    confirmScore: "确认得分",
    export1: "导出",
    PersonID: "人员ID",
    department1: "部门",
    KPIScore1: "KPI得分",
    operate: "操作",
    checkDetails: "查看详情",
    Details: "详情",
    personType1: "人员类型",
    assessmentMethod: "考核方式",
    jobCategory: "职务分类",
    macPost: "主/副岗",
    assessmentID: "考核ID",
    programme: "方案",
    startingTime: "开始时间",
    endTime1: "结束时间",
    assessmentCycle: "考核周期",
    macPostWeight: "主副岗权重%", 
    doubleWeight: "双线权重%",
    doubleWeight2: "双线权重",
    TIWeight: "指标权重%",
    TPWeightScheme: "方案占比%",
    KPIScore2: "KPI",
    timeRatio: "时间占比",
    WAScore: "加权平均分数",
    PARate: "方案达成率%",
    GARate: "目标达成率%",
    //sti汇总得分
    TARate: "STI总达成率%",
    ISARate: "个人STI达成率",
    ESARate: "公司STI达成率",
    FARate: "最终达成率",
    WAARate: "加权平均达成率",
    interviewIdp: "面谈记录",
    competencyAppraisalResults: "能力考核结果",
    stiTotalAchievementRate: "STI总达成率",
    annualKPIAchievementRate: "年度KPI达成率",
    annualKPI: "年度KPI",
    abilityAssessment: "能力考核",
    annualComprehensiveScore: "年度综合得分",
    annualComprehensiveGrade: "年度综合等级",
    thInterview: "次面谈",
    section: "第",
    recorder: "记录人",
    individualDevelopmentPlan: "发展计划（可选）",
    toBeDevelopedGoal: "待发展项",
    developmentGoals: "发展目标",
    completionDescription: "完成情况描述",
    uploadAttachments: "上传附件",
    actionPlanDescription: "计划内容",
    cancellationReasonCheckTips: "请输入取消原因",
    actualCompletionTimeCheckTips: "请选择完成时间",
    hrTodo: "HR待办",
    employeeInformationToBeMaintained: "员工信息待维护",
    targetToFollow: "目标待跟进",
    evaluationToBeFollowedUp: "评估待跟进",
    complaintToBeFollowedUp: "申诉待跟进",
    comprehensiveEvaluationToBeReviewed: "综合考评待审核",
    interviewIDPNotStarted: "面谈&PIP未开始",
    myTeam: "我的团队",
    annualComprehensiveAssessmentScoresAndGrades: "年度综合考核得分及等级",
    companyTargetExportReport: "公司绩效评分报表",
    functionalPerformanceTargetImport: "职能绩效目标导入",
    todo2: "待处理",
    submitted2: "已提交",
    KPICompute: "KPI计算",
    STICompute: "STI计算",
    CACompute: "能力考核计算",
    CCCompute: "综合结果计算",
    notSubmitted: "未提交",
    calculationItems: "计算项目",
    confirmCalculationResults: "确认计算结果",
    annualKPIAchievementRate: "年度KPI达成率",
    annualComprehensiveScore: "年度综合得分",
    KPIAchievementRate: "KPI达成率%",
    TotalKPIAchievementRate: "总KPI达成率%",
    TotalKPIAchievementRate2: "总KPI达成率",
    assessmentType: "考核类型",
    WAARate: "加权平均达成率",
    capacityCategory: "能力大类",
    score1: "得分",
    weight1: "权重",
    DLAweight: "双线考核权重",
    PleaseSelectAnnualOrganization: "请选择年度组织",
    PleaseSelect: "请选择带星选项框后再计算",
    PleaseSelect1: "请选择带星选项框后再查询",
    submissionTime: "提交时间",
    actualCheckTips: "指标实际值不能为空",
    functionAppraisalCycleMaintenance: "职能考核周期维护",
    assessTypeCheckTips: "仅能批量提交单一考核类型目标",
    executivePerformanceSummary: "高管绩效汇总表",
    englishName: "英文名字",
    chinahName: "中文名字",
    countryOfContract: "签约地",
    bonusProportion: "奖金比例",
    targets: "指标",
    stiSpread: "奖金水平",
    totalAchieved: "总达成率",
    specificationOfTarget: "说明",
    achievingRateCompanyCheckTips: "公司达成率为空",
    itemTypeCheckTips: "请选择待发展项",
    progressCheckTips: "请选择进度",
    planTypeCheckTips: "请选择行动计划",
    planContentCheckTips: "请输入计划内容",
    outputResultCheckTips: "请输入输出结果",
    evaluationType: '测评类型',
    TMCScore: "TMC得分",
    scoreAfterModification: "修改后得分",
    LastUpdatedBy: "最后更新人",
    updateTime: "更新时间",
    abilityResults: "能力结果",
    rank: "排名",
    Check: "查看",
    performanceLevel: "绩效等级",
    originalGrade: "原等级",
    suggestionsFromSuperiors: "上级建议",
    departmentRecommendations: "部门建议",
    forcedDistribution: "强制分布",
    finalGrade: "最终等级",
    reject: "驳回",
    KPIAssessment: "KPI考核(50%)",
    comprehensiveCapacity: "综合能力(50%)",
    originalGrade1: "原始等级",
    recommendationLevel: "建议等级",
    ratingLevel: "评分等级",
    confirmRanking: "确认排名",
    unlockSuccess: "解锁成功",
    unlockTips: "解锁后HR可直接修改结果，无需走申诉审批流程",
    unlockTips2: "解锁后HR可直接修改目标，无需走目标修改审批流程",
    unlockPartTips1: "确认要解锁",
    unlockPartTips2: "的评估吗",
    unlockPartTips3: "的目标吗",
    synchronizeTMCResults: "同步TMC结果",
    employeeTitle: "员工职别",
    raterID: "评分人ID",
    rater: "评分人",
    scoringTime: "评分时间",
    obtain: "获取",
    excellent2: '优秀',
    good: '良好',
    qualified: '合格',
    unqualified: '不合格',
    rankingQuery: '排名查询',
    resultQuery2: '结果查询',
    interviewIdpInquiry: '面谈记录',
    viewAttachments: '查看附件',
    departmentName: '部门名称',
    employeesInvolvedInAssessment: '参与考核员工',
    updatedBy: '更新人',
    includingIndividualSTIAchievement: '其中:职能个人STI达成率',
    copyTMCDevelopItem: '复制TMC待发展项',
    summaryStatus: '汇总状态',
    comprehensiveSummary: '综合汇总',
    rankingStatus: '排名状态',
    rating: '评等',
    rankingOfDepartmentHeads: '部门负责人排名',
    rankingOfCompanyPrincipals: '公司负责人排名',
    employeeConfirmation: '员工确认',
    leadershipScore: '领导力得分',
    leadershipPillar: '领导力支柱',
    leadershipDescription: '领导力描述',
    abilityEvaluation: '能力测评',
    secondaryConfirmReject:'是否确认驳回',
    cancelReject:'取消驳回',
    tmcCapabilityAssessmentModification:'TMC能力评估修改',
    tmcScoreEdit:'TMC修改',
    tmcScoreDetail:'TMC详情',
    summaryScore:'汇总得分',
    summaryCalUnlock:'汇总计算解锁（IT）',
    rateListDetail:'评等详情',
    deptRank5:'五级部门排名',
    deptRank5Detail:'五级部门排名-详情',
    companyChargeRankDetail:'公司负责人排名-详情',
    actualsuggestions:'实际|建议',
    selectAssessmentMethod:'请选择考核方式',
    weightSumConfirm:'权重之和必须为100',
    grade:'等级',
    tmcWeightSetInfo:'说明：请维护该员工每一条能力得分的考核方式（行政线/业务线/不计评分），并维护权重。行政线的权重之和需要等于100%，业务线的权重不要单独维护。',
    change: '变更',
    urge: '催办',
    completed: '已完成',
    inProgress: '进行中',
    notStarted: '未开始',
    statusStatisticsOfDevItem: '待发展项状态统计',
    interviewIDPCheckTips: '已完成状态的面谈&PIP不能催办',
    forcedDistributionLevel: '强制分布等级',
    FARatePercent: "最终达成率%",
    totalAchievedPercent:"总达成率%",
    tmcSyncInfo:'查看同步进度',
    viewImportProgress: '查看导入进度',
    tmcSyncMessage:'同步请求已提交,结果请到"查看同步结果"按钮查看',
    distributionStandard:'强制分布标准',
    allowDistributionStandard:'符合标准',
    inconformityDistributionStandard:'高于强制分布上限，低于强制分布下限',  //无用了
    saveConfirm:'页面存在未保存内容,是否保存',
    noSave:'不保存',
    cancelSave:'取消保存',
    inconformityDistributionStandardTips:'仍有数据不符合强制分布要求,无法提交评分',
    employee:'员工',
    good2:'良',
    refresh:'刷新',
    deptlead2: "包含部门负责人",
    comprehensive:"综合",
    personSelect:"当前已选择",
    person:"人",
    search2:'搜索',
    secondConfirmationScorePrompt: '请再次确认是否为最终分数？系统仅提供一次修改分数的机会，一旦确认不可再次修改。',
    suggeestionsNumber:'建议数',
    actualNumber:'实际数',
    directReportsDistribution:'直接下属强制分布',
    deptDistribution:'部门强制分布',
    companyDistribution:'公司强制分布',
    comprehensiveCalculation:"综合考评结果计算",
    directReportsDistributionDetail:'直接下属强制分布-详情',
    deptDistributionDetail:'部门强制分布-详情',
    companyDistributionDetail:'公司强制分布-详情',
    forcedDistributionDetail: "强制分布-详情",
    comprehensiveResults:'综合结果',
    myPerformanceTodo: '我的绩效-待办',
    myPerformanceQuery: '我的绩效-绩效查询',
    viewFunctionAppraisalObjectives: '职能考核目标查看',
    revisionOfFunctionalAssessmentObjectives: '职能考核目标修正',
    functionalAssessmentObjectiveSetting: '职能考核目标设定',
    confirmationOfFunctionalAssessmentObjectives: '职能考核目标确认',
    functionalAssessment: '职能考核评估',
    salesAndMarketAssessment: '销售/市场考核评估',
    seniorManagementAssessment: '高管考核评估',
    interviewAndIDPMaintenance: '面谈&PIP维护',
    interviewAndIDPDetails: '面谈&PIP详情',
    teamPerformanceTodo: '团队绩效-待办',
    teamPerformanceQuery: '团队绩效-绩效查询',
    departmentObjectiveMaintenance: '部门目标维护',
    departmentObjectiveDetails: '部门目标详情',
    unlockAppraisalInformation: '考核信息解锁',
    salesAndMarketAssessmentObjectives: '销售/市场考核目标',
    executiveAssessmentObjectives: '高管考核目标',
    groupYearConfirmationPrompt: '此年度组织已经更新了纳入部门信息，如果确定编辑，此年度组织已经执行的强制分布数据会全部清除，请确定是否需要确定编辑？',
    personalPlanEmpty:'个人发展计划不能为空',
    noInterviewRecord:'无面谈记录',
    IDPnoStart:'待发展项-未开始',
    IDPprogress:'待发展项-进行中',
    stateError:'状态获取失败',
    manuallySelected:'已做人工选择待发展项，不可再从TMC系统复制',
    correctionNotFilled:'存在未填写的修正评分',
    helperTips:'请输入协助人',
    developmentGoalsTips:'请输入发展目标',
    completionDescriptionTips:'请输入完成情况描述',
    batchCalculationOfSTI:'批量计算STI达成率',
    STIDetail:'STI详情',
    DevelopmentPlanStatus:'发展计划状态',
    DevelopmentPlanStatusOption:'发展计划（可选）',
    planNumber: '计划编号',
    pip: '绩效改进计划',
    planStatus: '计划状态',
    trackStatus: '跟踪状态',
    planUrge: '计划催办',
    trackUrge: '跟踪催办',
    submitTime: '提交日期',
    submitTimeTips:'请选择提交日期',
    PeriodicityNotEstablished:'周期未设定',
    pipNumber: '计划编号',
    emplId: '工号',
    planFormulationDate: '计划制定日期',
    withoutPerformanceImprovementPlan: '未做绩效改进计划人员',
    print: '打印',
    selectAll: '全选',
    printSelection: '打印选择',
    action: '操作',
    indexNum: '序号',
    trackingRecords: '跟踪记录',
    pipMethod: '绩效表现中存在哪些需要改进地方（尽可能详细并列举说明）',
    pipContent: '绩效改进期望达到效果是什么(尽可能列出衡量标准)',
    pipMeasure: '绩效改进行动计划',
    trackingResult: '基于行动计划的实际绩效结果',
    trackingAction: '后续行动',
    uploadSupportFiles: '上传证明文件',
    quit: '退出',
    performanceTrackingRecords: '绩效跟踪记录',
    pieceRate: "计件",
    function: "职能",
    sales: "销售",
    market: "市场",
    newEntry:'新入职',
    resignation:'离职',
    retire:'退休',
    transferjob:'岗位变动',
    endOfPartTimeJob:'兼职结束',
    otherChanges:'其他变更',
    salaryCategoryConversion:'薪资类别转换',
    degradation: '降级',
    resignation: '离职',
    retirement: '退休',
    termination: '内退',
    otherChanges: '其他变更',
    hire: '入职',
    transfer: '员工调动',
    rehire: '离职回聘',
    promotion: '晋升',
    addAssistant: '新增副岗',
    invalidAssistant: '失效副岗',
    retireReturn: '退休返聘',
    payChange: '薪资信息更改',
    contractWorker: '合同工',
    laborWorker: '劳务工',
    laborDispatchPersonnel: '劳务派遣人员',
    earlyRetiree: '内退人员',
    intern: '实习生',
    hourlyWorker: '小时工',
    socialWorker: '社工',
    contract: 'Contract',
    temporary: 'Temporary',
    laborDispatchPersonnelB: '劳务派遣人员B',
    recorder: '记录人',
    printSelection: '打印选择',
    cancelCalculationResults: "取消确认结果",
    urgeSuccess: '催办成功',
    urgeFail: '催办失败',
    yearFormatError: '年度不能为空',
    No1: '第1次跟踪记录',
    No2: '第2次跟踪记录',
    No3: '第3次跟踪记录',
    No4: '第4次跟踪记录',
    No5: '第5次跟踪记录',
    No6: '第6次跟踪记录',
    No7: '第7次跟踪记录',
    No8: '第8次跟踪记录',
    No9: '第9次跟踪记录',
    No10: '第10次跟踪记录',
    loading: '加载中',
    pipTips:'该员工未提交员工信息，请联系HR处理。',
    adjustmentValue:'调整值',

}

export default zh